module.exports = __webpack_public_path__ + "static/img/PS-NA2_80A.85caf70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/PS-NA2_80A.png
// module id = KgIY
// module chunks = 1